import React from 'react';

export function ShareIcon({
  width = 32,
  fillColor = 'white',
  ariaLabel = 'Share icon',
}: {
  width?: number;
  fillColor?: string;
  ariaLabel?: string;
}) {
  return (
    <svg
      aria-label={ariaLabel}
      viewBox="0 0 35 40"
      width={width}
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.83 0l6.902 7.84C3.926 14.724-4.106 29.164 2.221 40c4.843-18.386 18.99-22.765 18.99-22.765l3.38 9.788L34.835 2.936 8.83 0z" />
    </svg>
  );
}
